import React from 'react'
import { FormField } from '../../../../Common/FormField'
import { handleKeyDown } from '../../EnrollmentPeriod/validate'
import { HandleYearChangeFunction } from '../../EnrollmentPeriod/types'
import styles from './CompanyNameWithPeriod.module.css'

interface WorkPeriodFieldsProps {
    workStartYear: string
    workStartMonth: string
    workEndYear: string | null
    workEndMonth: string | null
    isTenure: boolean
    hasInteractedPeriod: boolean
    startDateError: string
    endDateError: string
    onStartYearChange: HandleYearChangeFunction
    onStartMonthChange: (_value: string) => void
    onEndYearChange: HandleYearChangeFunction
    onEndMonthChange: (_value: string) => void
}

const normalizeMonthValue = (value: string): string => {
    const numericValue = value.replace(/[^0-9]/g, '')
    const MAX_MONTH_LENGTH = 2
    return numericValue.length > MAX_MONTH_LENGTH
        ? numericValue.replace(/^0+/, '')
        : numericValue
}

const isValidMonth = (value: string): boolean => {
    const MAX_MONTH = 12
    return value === '' || parseInt(value, 10) <= MAX_MONTH
}

export const WorkPeriodFields = ({
    workStartYear,
    workStartMonth,
    workEndYear,
    workEndMonth,
    isTenure,
    hasInteractedPeriod,
    startDateError,
    endDateError,
    onStartYearChange,
    onStartMonthChange,
    onEndYearChange,
    onEndMonthChange,
}: WorkPeriodFieldsProps) => {
    const handleMonthChange = (value: string, setMonth: (_value: string) => void) => {
        const normalizedValue = normalizeMonthValue(value)
        if (isValidMonth(normalizedValue)) {
            setMonth(normalizedValue)
        }
    }

    return (
        <div className={styles.periodSection}>
            <div className={styles.periodField}>
                <FormField
                    label="勤務開始年"
                    placeholder="年"
                    value={workStartYear}
                    isInputType="tel"
                    onChange={onStartYearChange}
                    onKeyDown={handleKeyDown}
                />
                <FormField
                    label="勤務開始月"
                    placeholder="月"
                    value={workStartMonth}
                    isInputType="tel"
                    onChange={value => handleMonthChange(value, onStartMonthChange)}
                    onKeyDown={handleKeyDown}
                />
            </div>
            {hasInteractedPeriod && startDateError && (
                <div>
                    <p className={styles.errorMessages}>{startDateError}</p>
                </div>
            )}

            {!isTenure && (
                <>
                    <div className={styles.periodField}>
                        <FormField
                            label="勤務終了年"
                            placeholder="年"
                            value={workEndYear || ''}
                            isInputType="tel"
                            onChange={onEndYearChange}
                            onKeyDown={handleKeyDown}
                        />
                        <FormField
                            label="勤務終了月"
                            placeholder="月"
                            isInputType="tel"
                            value={workEndMonth || ''}
                            onChange={value => handleMonthChange(value, onEndMonthChange)}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                    {hasInteractedPeriod && endDateError && (
                        <div>
                            <p className={styles.errorMessages}>{endDateError}</p>
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

